import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { setEventEmitter } from '../../../pageLayouts/eventEmitters/eventEmitters.utils';
import { primaryHeaderHeight } from '../header.utils';
import { Link } from '../../../../partials/link/Link';

export interface InjectedVideoLogoApiProps {
    videoPath: string
}

export interface InjectedVideoLogoDataProps {
    href: string
}

type InjectedVideoLogoProps = InjectedVideoLogoApiProps & InjectedVideoLogoDataProps;

const embeddedVideoLogoPaddingInPx = 20;

const getInjectedVideoLogoStyle = () => {
  return StyleSheet.create({
    wrapper: {
      height: `${primaryHeaderHeight}px`,
    },
    video: {
      height: '100%',
      alignItems: 'center',
      display: 'inline-flex',
      margin: `0 -${embeddedVideoLogoPaddingInPx}px`,
    },
    source: {
      height: '100%',
    },
  });
};

export const VideoLogo: React.FunctionComponent<InjectedVideoLogoProps> = props => {
  const { videoPath, href } = props;
  const style = getInjectedVideoLogoStyle();

  React.useEffect(() => {
    setEventEmitter('injectVideoLogoSuccessfully', (callback:Function) => callback());
  }, [videoPath]);

  return (
    <Link className={css(style.wrapper)} href={href}>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video className={css(style.video)} loop autoPlay muted>
        <source className={css(style.source)} src={videoPath} type="video/mp4" />
      </video>
    </Link>
  );
};
